import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  className: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const AngleLeftIcon = ({
  color = '#B5BCBD',
  className,
  width = '14',
  height = '24',
}) => (
  <svg
    viewBox="0 0 14 24"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    width={width}
    height={height}
  >
    <path
      fill={color}
      d="M11.9 23.9l2.1-2.1-8.3-8.3L4.2 12l1.5-1.5L14 2.2 11.9.1 0 12z"
    />
  </svg>
);

AngleLeftIcon.propTypes = propTypes;

export default AngleLeftIcon;
